export var DEFAULT_LOCALE = "en";
export var LOCALE_COOKIE = "userLocale";
export var LOCALE_LABELS = {
    "en-US": "English",
    en: "English",
    nl: "Nederlands",
    fr: "Fran\xe7ais",
    de: "Deutsch",
    es: "Espa\xf1ol",
    it: "Italiano",
    pt_BR: "Portugu\xeas",
    pt: "Portugu\xeas",
    ja_JP: "日本語",
    ja: "日本語",
    ko: "한국어",
    ar: "العربية",
    ru: "Русский",
    tr: "T\xfcrk\xe7e",
    th: "ไทย",
    pl: "Polski"
};
export var RTL_LANGUAGES = [
    "ar",
    "he"
];
